
import { BaseApiTemplateService, Core2Config } from "../../shared";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import { DriveContainerModel } from "../../../../../../../lib/models/aggregates/fm/drive";

@Injectable({providedIn: "root"})
export class DriveService extends BaseApiTemplateService<DriveContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FM_MODULE + 'drives';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FM_MODULE + 'drives';
    this.httpClient = http;
  }
}
